import React, { useState, useEffect } from 'react';
import {
    Sidebar, SidebarNav, SidebarLayout,
    Container, RowView, Col, Navbar, Heading, Paragraph,
    Button, CardView, Image, Input, Spacer,
    Alert, Badge, ListView, ListItem, Flex, Grid,
    Table, Progress, Spinner, Dropdown, Link,
    Modal, Tabs, Divider, Text,
    useResponsive, MobileOnly, DesktopOnly, TabletOnly
} from './MainCompontes/index';
import { Nav } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import './MainCompontes/MainComponents.css';
import ImageShow from '../Uitiles/ImageShow';
import { useSettings } from '../context/SettingsContext';
import useOs from '../hooks/Os';
import { getuserdata, encryptId, formatUrlString, getroles, loginapi } from "../services/apiService";
import { useAuth } from "../context/AuthContext";
import { toast } from 'react-toastify';
import SidebarController from "../controllers/SidebarController";

const CommonLayout = ({ children, userType = "" }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedPage, setSelectedPage] = useState('dashboard');
    const [notifications, setNotifications] = useState(5);

    const platformInfo = useOs();
    // Use responsive hook
    const screen = useResponsive();
    const { settings } = useSettings();
    const [userdata, setUserData] = useState({});
    const [displayName, setDisplayName] = useState("");
    const [menuList, setMenuList] = useState([]);
    const [userRole, setUserRole] = useState("");
    const [userPermissions, setUserPermissions] = useState([]);
    const { logout, login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [sidebarItems, setSidebarItems] = useState([]);

    const toggleSubmenu = (path, event) => {
        event.preventDefault();
        event.stopPropagation();

        const updatedMenuList = [...menuList];
        SidebarController.toggleSubmenu(updatedMenuList, path);

        setMenuList(updatedMenuList);
    };

    useEffect(() => {
        getUserProfile();

    }, []);

    useEffect(() => {
        if (userdata.user_type) {
            buildMenu();
        }
    }, [userType, userRole, userdata]);


    const getUserProfile = async () => {
        const data = await getuserdata("full");
        console.log("getUserProfile data :", data);

        if (data) {
            setDisplayName(data.display_name || data.name || "");
            setUserRole(data.user_type);
            console.log("userRole", data.user_type);
            setUserPermissions(data.permissions || []);
            setUserData(data);
        } else {
            console.warn("getUserProfile: No user data returned.");
        }
    };

    const buildMenu = async () => {
        let permissions = [];
        console.log("buildMenu userdata:", userdata);

        if (userdata && userdata.role) {
            try {
                const getpermissions = await getroles(userdata.role);
                console.log("getpermissions buildMenu :", getpermissions);
                if (getpermissions && getpermissions.data && getpermissions.data.length > 0) {
                    permissions = getpermissions.data[0].permissions || [];
                }
            } catch (error) {
                console.error("Error fetching permissions:", error);
            }
        } else {
            console.log("buildMenu: No role defined for user, skipping permissions fetch.");
        }

        console.log("buildMenu using permissions:", permissions);
        setUserPermissions(permissions);

        // Ensure displayName is valid
        const safeDisplayName = displayName || (userdata ? (userdata.display_name || userdata.name || "") : "");

        const menu = SidebarController.buildMenu(userdata, permissions, safeDisplayName, setSelectedPage);
        console.log("menu buildMenu :", menu);
        setSidebarItems(menu);
    };

    // Initialize platform on mount (works even without Capacitor installed)
    React.useEffect(() => {
        const initPlatform = async () => {
            try {
                const { initializeCapacitor } = await import('./MainCompontes/index');
                await initializeCapacitor();
            } catch (error) {
                console.log('Running without Capacitor:', error.message);
            }
        };
        initPlatform();
    }, []);

    // // Sidebar navigation items
    // const sidebarItems = [
    //     {
    //         icon: '🏠',
    //         label: 'Dashboard',
    //         key: 'dashboard',
    //         link: '/superadmin/dashboard',
    //         active: selectedPage === 'dashboard',
    //         children: [
    //             {
    //                 icon: '🏠',
    //                 label: 'Dashboard Page',
    //                 key: 'dashboard',
    //                 link: '/superadmin/dashboard',
    //                 active: selectedPage === 'dashboard',
    //             },
    //             {
    //                 icon: '📊',
    //                 label: 'Analytics Page',
    //                 key: 'analytics',
    //                 link: '/superadmin/analytics',
    //                 active: selectedPage === 'analytics',
    //             },
    //             {
    //                 icon: '👥',
    //                 label: 'Users Page',
    //                 key: 'users',
    //                 link: '/superadmin/users',
    //                 active: selectedPage === 'users',
    //             },
    //         ]
    //     },
    //     {
    //         icon: '📊',
    //         label: 'Analytics',
    //         key: 'analytics',
    //         badge: 'Pro',
    //         badgeColor: '#28a745'
    //     },
    //     {
    //         icon: '👥',
    //         label: 'Users',
    //         key: 'users',
    //         badge: '1.2k',
    //         badgeColor: '#007bff'
    //     },
    //     {
    //         icon: '📦',
    //         label: 'Products',
    //         key: 'products'
    //     },
    //     { divider: true },
    //     { header: 'Management' },
    //     {
    //         icon: '⚙️',
    //         label: 'Settings',
    //         key: 'settings'
    //     },
    //     {
    //         icon: '📝',
    //         label: 'Reports',
    //         key: 'reports'
    //     },
    //     {
    //         icon: '💬',
    //         label: 'Messages',
    //         key: 'messages',
    //         badge: notifications,
    //         badgeColor: '#dc3545'
    //     },
    //     { divider: true },
    //     {
    //         icon: '❓',
    //         label: 'Help & Support',
    //         key: 'help'
    //     }
    // ];

    // Stats data
    const stats = [
        {
            title: 'Total Revenue',
            value: '$45,231',
            change: '+12.5%',
            changeType: 'positive',
            icon: '💰',
            bg: 'primary'
        },
        {
            title: 'New Users',
            value: '1,234',
            change: '+8.2%',
            changeType: 'positive',
            icon: '👥',
            bg: 'success'
        },
        {
            title: 'Orders',
            value: '892',
            change: '-3.1%',
            changeType: 'negative',
            icon: '📦',
            bg: 'warning'
        },
        {
            title: 'Conversion Rate',
            value: '3.45%',
            change: '+1.2%',
            changeType: 'positive',
            icon: '📈',
            bg: 'info'
        }
    ];

    // Recent orders data
    const recentOrders = [
        { id: '#12345', customer: 'John Doe', product: 'Product A', amount: '$125.00', status: 'Completed' },
        { id: '#12346', customer: 'Jane Smith', product: 'Product B', amount: '$89.50', status: 'Pending' },
        { id: '#12347', customer: 'Bob Johnson', product: 'Product C', amount: '$220.00', status: 'Completed' },
        { id: '#12348', customer: 'Alice Williams', product: 'Product D', amount: '$156.75', status: 'Processing' },
        { id: '#12349', customer: 'Charlie Brown', product: 'Product E', amount: '$99.00', status: 'Completed' }
    ];

    // Recent activities
    const activities = [
        { icon: '✅', text: 'New order received', time: '2 minutes ago', type: 'success' },
        { icon: '👤', text: 'New user registered', time: '15 minutes ago', type: 'info' },
        { icon: '📦', text: 'Product updated', time: '1 hour ago', type: 'primary' },
        { icon: '💬', text: 'New message from support', time: '2 hours ago', type: 'warning' },
        { icon: '🔔', text: 'System maintenance scheduled', time: '5 hours ago', type: 'danger' }
    ];

    const handleLogout = () => {
        try {
            // Use the proper logout function from AuthContext
            logout();
        } catch (error) {
            console.error("Error during logout:", error);
            // Fallback to manual logout
            localStorage.clear();
            sessionStorage.clear();
            navigate("/", { replace: true });
            window.location.reload();
        }
    };

    const handleLoginReturn = async () => {
        console.log('Attempting return to original dashboard...');
        const localuser = localStorage.getItem("presentuser");
        const redirect_url = localStorage.getItem("redirect_url_admin") || "/admin/dashboard";

        if (!localuser) {
            toast.error("No original session found.");
            return;
        }

        try {
            const parsedData = JSON.parse(localuser);
            const loginResponse = await loginapi(parsedData.email, parsedData.pass, true);

            const user = loginResponse.data[0];

            if (user) {
                if (user.status === "2") {
                    toast.error("Your account has been deleted. Please contact support.");
                    return;
                }

                const userData = {
                    id: user.id,
                    email: user.email,
                    user_type: user.user_type || "user",
                    display_name: user.display_name || user.email
                };

                const loginSuccess = await login(userData);

                if (loginSuccess) {
                    toast.success("Returned to original session!", { autoClose: 2000 });
                    navigate(redirect_url);
                } else {
                    toast.error("Failed to restore session.");
                }
            } else {
                toast.error("Original user not found.");
            }
        } catch (error) {
            console.error("Error during return session:", error);
            toast.error("An error occurred while returning to dashboard.");
        }
    }

    const handleNavSelect = (key) => {
        // Find the menu item in sidebarItems or its children
        const findMenuItem = (items, key) => {
            for (const item of items) {
                if (item.key === key) return item;
                if (item.children) {
                    const found = findMenuItem(item.children, key);
                    if (found) return found;
                }
            }
            return null;
        };

        const clickedItem = findMenuItem(sidebarItems, key);

        if (clickedItem && clickedItem.action === "logout") {
            handleLogout();
            return;
        }

        if (clickedItem && clickedItem.action === "login_return") {
            handleLoginReturn();
            return;
        }

        setSelectedPage(key);
    };

    return (
        <SidebarLayout
            sidebarPosition="left"
            sidebarWidth="250px"
            sidebar={
                <>
                    {/* Logo/Brand */}
                    <Flex justify="left" align="center" style={{ marginBottom: '30px' }}>
                        <Heading level={3} style={{ color: 'white', margin: 0 }}>
                            <ImageShow url={settings.footer_logo_url} width={150} />
                        </Heading>
                    </Flex>

                    {/* User Profile Card */}
                    <CardView
                        bg="dark"
                        className="user-profile-card"
                        text="white"
                        style={{ marginBottom: '20px', border: '1px solid #34495e' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <div style={{ width: '48px', height: '48px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                                <ImageShow
                                    url={userdata.profile_photo_url}
                                    style={{
                                        borderRadius: '50%',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        display: 'block'
                                    }}
                                    width={48}
                                    height={48}
                                />
                            </div>
                            <div>
                                <Text tag="div" style={{ fontWeight: 'bold', color: 'white' }}>
                                    {userdata.first_name} {userdata.last_name}
                                </Text>
                                <Text tag="small" style={{ color: '#95a5a6' }}>
                                    {userdata.email}
                                </Text>
                            </div>
                        </div>
                    </CardView>

                    {/* Navigation */}
                    <SidebarNav
                        items={sidebarItems}
                        activeKey={selectedPage}
                        onSelect={handleNavSelect}
                    />

                    <Spacer height="20px" />

                    {/* Logout Button removed to avoid duplication - now in dynamic menu */}
                </>
            }
            navbar={
                <>
                    <Container fluid>
                        <Flex justify="space-between" align="center" style={{ width: '100%', padding: '0px !important' }}>

                            <MobileOnly>
                                <ImageShow
                                    url={settings.logo_url}
                                    width={150}
                                    height={50}
                                    style={{ cursor: 'pointer' }}
                                />
                            </MobileOnly>
                            <TabletOnly>
                                <Flex align="center" gap="12px">
                                    {!['/superadmin/dashboard', '/admin/dashboard'].includes(location.pathname) && (
                                        <button 
                                            onClick={() => {
                                                if (location.pathname.includes('doctor-profile')) {
                                                    navigate('/superadmin/doctors');
                                                } else if (location.pathname.includes('hospital-profile')) {
                                                    navigate('/superadmin/hospitals');
                                                } else {
                                                    navigate(-1);
                                                }
                                            }}
                                            className="btn btn-link p-0 text-dark d-flex align-items-center"
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <i className="lnr lnr-arrow-left font-weight-bold" style={{ fontSize: '18px' }}></i>
                                        </button>
                                    )}
                                    <Heading level={4} style={{ margin: 0 }}>
                                        {location.pathname.includes('doctor-profile') ? 'Doctor Profile' :
                                         location.pathname.includes('hospital-profile') ? 'Hospital Profile' : 
                                         'Dashboard'}
                                    </Heading>
                                </Flex>
                            </TabletOnly>
                            <DesktopOnly>
                                <Flex align="center" gap="12px">
                                    {!['/superadmin/dashboard', '/admin/dashboard'].includes(location.pathname) && (
                                        <button 
                                            onClick={() => {
                                                if (location.pathname.includes('doctor-profile')) {
                                                    navigate('/superadmin/doctors');
                                                } else if (location.pathname.includes('hospital-profile')) {
                                                    navigate('/superadmin/hospitals');
                                                } else {
                                                    navigate(-1);
                                                }
                                            }}
                                            className="btn btn-link p-0 text-dark d-flex align-items-center"
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <i className="lnr lnr-arrow-left font-weight-bold" style={{ fontSize: '20px' }}></i>
                                        </button>
                                    )}
                                    <Heading level={4} style={{ margin: 0 }}>
                                        {location.pathname.includes('doctor-profile') ? 'Doctor Profile' :
                                         location.pathname.includes('hospital-profile') ? 'Hospital Profile' : 
                                         'Dashboard'}
                                    </Heading>
                                </Flex>
                            </DesktopOnly>


                            <Flex gap="15px" align="center">
                                {/* Notifications */}
                                <div style={{ position: 'relative' }}>
                                    <Button variant="outline-secondary">
                                        🔔
                                    </Button>
                                    {notifications > 0 && (
                                        <Badge
                                            bg="danger"
                                            pill
                                            style={{
                                                position: 'absolute',
                                                top: '-5px',
                                                right: '-5px',
                                                fontSize: '10px'
                                            }}
                                        >
                                            {notifications}
                                        </Badge>
                                    )}
                                </div>

                                {/* User Menu Dropdown */}
                                <Dropdown
                                    title="Profile"
                                    variant="outline-primary"
                                    items={[
                                        { label: 'My Profile', onClick: () => alert('Profile') },
                                        { label: 'Settings', onClick: () => alert('Settings') },
                                        { divider: true },
                                        { label: 'Logout', onClick: handleLogout }
                                    ]}
                                />
                            </Flex>
                        </Flex>
                    </Container>
                </>
            }
        >


            {/* DEBUG OVERLAY - REMOVE AFTER FIX
            <div style={{ position: 'fixed', bottom: '10px', right: '10px', background: 'rgba(0,0,0,0.8)', color: 'white', padding: '10px', borderRadius: '5px', zIndex: 99999, fontSize: '12px', maxWidth: '300px', wordWrap: 'break-word' }}>
                <strong>Debug Info:</strong><br />
                User Type: {userdata?.user_type || 'undefined'}<br />
                Role: {userRole || 'undefined'}<br />
                Sidebar Items: {sidebarItems?.length || 0}<br />
                ID: {userdata?.id || 'null'}<br />
                LS: {typeof window !== 'undefined' ? (localStorage.getItem('userData') || 'null').substring(0, 100) : 'N/A'}<br />
                Table: {userdata?.user_type === 'blood_bank' ? 'blood_bank' : (userdata?.user_type === 'diagnostic' ? 'diagnostics' : 'users?')}
            </div> */}

            {children}

            {/* New Order Modal */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                title="Create New Order"
                size="lg"
                footer={
                    <Flex gap="10px" justify="end">
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={() => {
                            alert('Order created!');
                            setShowModal(false);
                        }}>
                            Create Order
                        </Button>
                    </Flex>
                }
            >
                <Input
                    label="Customer Name"
                    type="text"
                    placeholder="Enter customer name"
                    required
                />
                <Input
                    label="Product"
                    type="text"
                    placeholder="Enter product name"
                    required
                />
                <Input
                    label="Quantity"
                    type="number"
                    placeholder="Enter quantity"
                    required
                />
                <Input
                    label="Amount"
                    type="text"
                    placeholder="Enter amount"
                    required
                />
                <Input
                    label="Notes"
                    as="textarea"
                    rows={3}
                    placeholder="Additional notes..."
                />
            </Modal>
        </SidebarLayout>
    );
};

export default CommonLayout;

